import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DOCUMENT} from '@angular/common';

const PATH =
  'M12 24C5.373 24 0 18.627 0 12h2c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2c-.453 0-.897.034-1.334.092V.076C11.104.028 11.549 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12Z';

@Injectable({providedIn: 'root'})
export class LoadingIndicatorService {
  private svg: HTMLDivElement | undefined;
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory2: RendererFactory2
  ) {
    this.renderer = rendererFactory2.createRenderer(null, null);
    this.createSvg();
  }

  displayLoadingIndicator(): void {
    this.renderer.appendChild(this.document.body, this.svg);
  }

  hideLoadingIndicator(): void {
    this.renderer.removeChild(this.document.body, this.svg);
  }

  private createSvg(): void {
    const wrapper: HTMLDivElement = this.document.createElement('div');
    wrapper.classList.add('loading-spinner-wrapper');

    const svg: SVGElement = this.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
    svg.setAttributeNS(null, 'x', '0px');
    svg.setAttributeNS(null, 'y', '0px');
    svg.setAttributeNS(null, 'viewBox', '0 0 24 24');
    svg.setAttributeNS(null, 'preserveAspectRatio', 'xMidYMid meet');
    svg.classList.add('loading-spinner');
    svg.style.width = '100px';
    svg.style.height = '100px';

    const g: SVGGElement = this.document.createElementNS('http://www.w3.org/2000/svg', 'g');

    const path: SVGPathElement = this.document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', PATH);
    path.classList.add('primary-path');

    g.appendChild(path);
    svg.appendChild(g);
    wrapper.appendChild(svg);

    this.svg = wrapper;
  }
}
